import { CandidateAiDataBuilder } from '../candidate-ai.types';

export const addAiScoreSlug = (builder: CandidateAiDataBuilder) =>
  builder.mutation<any, any>({
    query: ({ name, slug, scoreGroup }) => ({
      url: `/candidate-scores/candidate-score-types`,
      method: 'POST',
      body: { Name: name, Slug: slug, ScoreGroup: scoreGroup },
    }),
    invalidatesTags: () => [{ type: 'aiScore' }],
  });
